import { atom } from "jotai";
import Drawing from "../../types/Drawing";

const feedAtom = atom<Drawing[] | null>(null);

export { feedAtom };
